import React from "react";
import * as S from "./completedMatchListDetailContent.style";
import { Accordion } from "../../atoms/Accordion";
import { DetailDataItemBox } from "../../atoms/DetailDataItemBox";
import OrderStatusIndicator from "../../atoms/OrderStatusIndicator";
import dayjs from "dayjs";
import { formatPrice } from "../../../common/common.fn";
import { OrderType } from "../../../interface/transportation";
import { translatePaymentState } from "../../../lib/orderStateTranslator";
import { MemoItemBox } from "../../atoms/MemoItemBox";

interface CompletedMatchListDetailContentProps {
  detailData: OrderType;
}

const CompletedMatchListDetailContent = ({
  detailData,
}: CompletedMatchListDetailContentProps) => {
  console.log("detailData", detailData);
  return (
    <S.MainContentsItem>
      <S.MainContentsItemLayout>
        <OrderStatusIndicator orderState={detailData.order_state} />
        <S.DataItemBox>
          <S.DataHeadBox>
            <div style={{ whiteSpace: "nowrap" }}>
              <span>운송번호</span>
              {detailData.order_number}
            </div>
          </S.DataHeadBox>
        </S.DataItemBox>

        <S.MainContentItemBox>
          <S.MainContentAccordionLayout>
            <Accordion title="상차지" data={detailData.load_place_address}>
              <S.DataListBox>
                <DetailDataItemBox
                  label="터미널명"
                  content={detailData.load_place_name}
                />
                <DetailDataItemBox
                  label="선사"
                  content={detailData?.forwarder}
                />
              </S.DataListBox>
              <S.DataListBox>
                <DetailDataItemBox
                  label="컨테이너 규격"
                  content={detailData?.container_spec}
                />
                {/* <DetailDataItemBox
                  label="컨테이너 타입"
                  content={detailData?.container_type}
                /> */}
              </S.DataListBox>
              <DetailDataItemBox
                label="메모"
                content={detailData?.load_place_remark}
              />
            </Accordion>

            <Accordion
              title="작업지"
              data={detailData?.work_place_address || "-"}
            >
              <S.DataListBox>
                <DetailDataItemBox
                  label="업체명"
                  content={detailData?.work_place_name}
                />
                <DetailDataItemBox
                  label="업체 전화번호"
                  content={detailData?.work_place_tel}
                />
              </S.DataListBox>
              <S.DataListBox>
                <DetailDataItemBox
                  label="화주명"
                  content={detailData?.cargo_owner}
                />
                <DetailDataItemBox
                  label="내용중량"
                  content={
                    detailData?.cargo_weight
                      ? detailData.cargo_weight + "Ton"
                      : "-"
                  }
                />
              </S.DataListBox>
              <DetailDataItemBox
                label="작업시간"
                content={
                  detailData?.work_start_time
                    ? dayjs(detailData?.work_start_time).format(
                        "YYYY-MM-DD HH:mm"
                      )
                    : "-"
                }
              />

              <DetailDataItemBox
                label="메모"
                content={detailData?.work_place_remark}
              />
            </Accordion>
            <Accordion title="하차지" data={detailData?.unload_place_address}>
              <DetailDataItemBox
                label="터미널명"
                content={detailData?.unload_place_name}
              />

              <DetailDataItemBox
                label="메모"
                content={detailData?.unload_place_remark}
              />
            </Accordion>
          </S.MainContentAccordionLayout>

          <S.DataContainer>
            <S.DetailDataItemBoxLayout>
              <DetailDataItemBox
                label="컨테이너 No"
                content={detailData?.container_no}
              />
              <DetailDataItemBox
                label="Booking No"
                content={detailData?.bk_no}
              />
            </S.DetailDataItemBoxLayout>
            <S.DetailDataItemBoxLayout>
              <DetailDataItemBox
                label="요청사"
                content={detailData?.company_name}
              />
              <DetailDataItemBox
                label="연락처"
                content={detailData?.company_name}
              />
            </S.DetailDataItemBoxLayout>
            <S.DetailDataItemBoxLayout>
              <DetailDataItemBox
                label="운송 요금 지불 방법"
                content={translatePaymentState(detailData?.payment_method)}
              />
              <DetailDataItemBox
                label="예상요금"
                content={
                  formatPrice(detailData?.final_settlement_amount) + " 원"
                }
                contentColor="primary"
              />
            </S.DetailDataItemBoxLayout>
            <S.DetailDataItemBoxLayout>
              <DetailDataItemBox
                label="수출/수입"
                content={detailData?.import_export === 2 ? "수출" : "수입"}
              />
              <DetailDataItemBox
                label="인수증 필수 여부"
                content={detailData?.is_required_invoice ? "필수" : "선택"}
                contentColor={
                  detailData?.is_required_invoice ? "primary" : "gray"
                }
              />
            </S.DetailDataItemBoxLayout>
            <MemoItemBox label="메모" content={detailData?.remark} />
          </S.DataContainer>
        </S.MainContentItemBox>
      </S.MainContentsItemLayout>
    </S.MainContentsItem>
  );
};

export default CompletedMatchListDetailContent;
